import { render } from "./MathLevelPlay.vue?vue&type=template&id=5112e15c&ts=true"
import script from "./MathLevelPlay.vue?vue&type=script&lang=ts"
export * from "./MathLevelPlay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__